// src/pages/Contact.jsx
import PageBanner from '../components/ui/PageBanner';
import { contactInfo } from '../data';
import ContactIcon from "../components/ui/ContactIcon";
import './Contact.css';

export default function Contact() {
  return (
    <>
      <PageBanner title="Contact Us" crumbs={['Home', 'Contact Us']} />

      <section className="section">
        <div className="section-inner">
          <div className="contact__layout">
            {/* Info */}
            <div>
              <p className="section-label">Get In Touch</p>
              <h3 className="section-title">We're Here to Help</h3>
              <p className="section-text contact__intro">
                Reach out to Capital Care International Hospital for appointments, inquiries, or any
                healthcare needs. Our team is available to assist you.
              </p>
              <div className="contact__info-list">
                {contactInfo.map(item => {
                  const content = (
                    <>
                      <div className="contact__info-icon" aria-hidden="true">
                        <ContactIcon name={item.key} />
                      </div>
                      <div>
                        <h5 className="contact__info-label">{item.label}</h5>
                        <p className="contact__info-value">{item.value}</p>
                      </div>
                    </>
                  );

                  if (item.href) {
                    return (
                      <a
                        key={item.label}
                        className="contact__info-item contact__info-item--link"
                        href={item.href}
                        target={item.external ? "_blank" : undefined}
                        rel={item.external ? "noreferrer" : undefined}
                      >
                        {content}
                      </a>
                    );
                  }

                  return (
                    <div key={item.label} className="contact__info-item">
                      {content}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Form */}
            <div className="contact__form card">
              <h3 className="contact__form-title">Send Us a Message</h3>
              <div className="contact__form-fields">
                <input className="input" placeholder="Your Name" />
                <input className="input" placeholder="Email Address" />
                <input className="input" placeholder="Phone Number" />
                <select className="input">
                  <option value="">Subject</option>
                  <option>Appointment Request</option>
                  <option>General Inquiry</option>
                  <option>Insurance</option>
                  <option>International Patient Services</option>
                  <option>Feedback</option>
                </select>
                <textarea className="input contact__textarea" rows={5} placeholder="Your message..." />
                <button className="btn-primary contact__submit">Send Message</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map */}
      <div className="contact__map" aria-label="Map location">
        <iframe
          className="contact__map-iframe"
          title="G-8 Branch Capital Plaza, Islamabad, Pakistan"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps?q=G-8%20Branch%20Capital%20Plaza%2C%20Islamabad%2C%20Pakistan&output=embed"
        />
      </div>
    </>
  );
}
